import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { useActivationSet } from "../../../hooks/useActivationSet";
import { useSecondaryDomains } from "../../../hooks/useSecondaryDomains";
import type { CompetitorOption, CompetitorValueMap } from "../types";

export const useCompetitorsMap = () => {
    const { translate } = useTranslate();
    const { activationSet, isLoading: isActivationSetLoading } = useActivationSet();
    const { domains: secondaryDomains, isLoading: isSecondaryLoading } = useSecondaryDomains();

    const allCompetitorsValues = useMemo(() => {
        const primaryDomain = activationSet?.primaryDomain;
        const competitors = activationSet?.competitorsDomains ?? [];

        const entries: CompetitorValueMap = new Map<string, CompetitorOption>();

        if (primaryDomain) {
            entries.set(primaryDomain, {
                id: primaryDomain,
                label: translate("autocomplete.my-project.item.text", { domain: primaryDomain }),
                kind: "primary",
            });
        }

        competitors.forEach((competitor) => {
            entries.set(competitor, { id: competitor, label: competitor, kind: "primary" });
        });

        secondaryDomains.forEach((domain) => {
            if (!entries.has(domain)) {
                entries.set(domain, { id: domain, label: domain, kind: "secondary" });
            }
        });

        return entries;
    }, [activationSet, secondaryDomains, translate]);

    return {
        allCompetitorsValues,
        isLoading: isActivationSetLoading || isSecondaryLoading,
    };
};
